import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs'

import { AuthenticationService } from '../../core/authentication.service';
import { UserDetails } from '../../shared/interfaces/user-details';

@Component({
  selector: 'app-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.css']
})

export class SideBarComponent implements OnDestroy {
  userData: UserDetails = {
    username: '',
    isUserLoggedIn: false,
    isSuperUser: false
  }
  _userSubscription: Subscription
  constructor(private authenticationService: AuthenticationService, private router: Router) {
    this._userSubscription = authenticationService.savedUser.subscribe((userUpdate: UserDetails) => {
      this.userData = userUpdate
    })
  }
  ngOnDestroy() {
    this._userSubscription.unsubscribe()
  }

  logout() {
    this.userData = {
      username: '',
      isUserLoggedIn: false,
      isSuperUser:false
    }
    this.authenticationService.removeCredentials()
    this.router.navigateByUrl('/login')
    // display userInfo? userData.displayUserInfo()
  }
}
